// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/footer/about-card/about-card.component.scss
// module id = 108
// module chunks = 0